import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Add, BeenhereRounded, Create, Visibility } from '@material-ui/icons';

import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService.js';

import { WithApp } from 'contexts/appContext';
import { Link } from 'react-router-dom';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 150 },
  { Header: 'Periodo', accessor: 'period', width: 100 },
  { Header: 'Fec. inicio', accessor: 'start_date', width: 110 },
  { Header: 'Fec. final', accessor: 'end_date', width: 110 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Mto. Super.', accessor: 'supervisor_reward', width: 110 },
  { Header: 'Mto. Jefe.', accessor: 'sale_manager_reward', width: 110 },
  { Header: 'Aprovado', accessor: 'approved', width: 100 },
  { Header: 'Fec. Aprov.', accessor: 'approved_date', width: 110 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Comentario', accessor: 'comments' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Incentive(props) {
  const classes = useStyles();

  const [incentives, setIncentives] = useState([]); //constante para el listado

  const [dataLoading, setDataLoading] = useState(false);
  //recargar Listado para usar en create y update
  async function listIncentives(filter) {
    setDataLoading(true);
    let response = await wsFindBy('com/incentive', filter);
    setDataLoading(false);
    if (response.success) setIncentives(response.data);
  }

  return (
    <Card>
      <CardHeader icon>
        <AllowedGuard
          permission={ConstantPermissions.LOGI_MARKS_STORE}
          component={
            <CardIcon color="primary">
              <BeenhereRounded style={{ color: 'white' }} />
            </CardIcon>
          }
        >
          <Link to="nuevo">
            <CardIcon pointer="true" color={props.themeContext.buttonColorSuccess}>
              <Add style={{ color: 'white' }} />
            </CardIcon>
          </Link>
        </AllowedGuard>
        <h4 className={classes.cardIconTitle}>Listado de incentivos {dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <FilterCustom
          getFilter={listIncentives}
          date
          dateType="month"
          labelDate="Periodo"
          dateField="period_date"
          zone
          state
          optionValues={['Y', 'N']}
          nameState="approved"
          nameOptions={['Aprobado', 'No Aprobado']}
        />
        <ReactTable
          excelName="Incentivos"
          defaultWidth={2300}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={incentives.map((item, i) => {
            //mapeando listado para las acciones
            return {
              num: (
                <div className="actions-right">
                  {i + 1}
                  <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_SHOW}>
                    <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                      <Link to={`${item.id}/editar`}>
                        <Create style={{ color: '#ff9800' }} />
                      </Link>
                    </Button>
                    <Button justIcon round simple color={props.themeContext.buttonColor}>
                      <Link to={`${item.id}`}>
                        <Visibility />
                      </Link>
                    </Button>
                  </AllowedGuard>
                </div>
              ),
              base_zone_description: `${item.base_zone_code || ''}${
                ' - ' + item.base_zone_description || ''
              }`,
              period: item.period,
              start_date: item.start_date,
              end_date: item.end_date,
              description: item.description,
              supervisor_reward: currency(item.supervisor_reward),
              sale_manager_reward: currency(item.sale_manager_reward),
              approved: item.approved === 'Y' ? 'Si' : item.approved === 'N' ? 'No' : '-',
              approved_date: item.approved_date,
              created_user_name: item.created_user_name,
              approved_user_name: item.approved_user_name,
              comments: item.comments,
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
